import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../deps';

import './BackstagePodcastEpisodeListItem.scss';

export const BackstagePodcastEpisodeListItem = props => {
  if (props.sectionLabel && props.sectionLabel.length > 0) {
    const labelClass = D.createBEM('BackstagePodcastEpisodeListItem__year', {
      first: props.index === 0,
    });
    return (
      <div className='BackstagePodcastEpisodeListItem'>
        <div className={labelClass}>{props.sectionLabel}</div>
      </div>
    );
  }

  return (
    <D.PodcastEpisodeRowItem
      id={props.pandoraId}
      showDescription={true}
      showCollectedBadge={true}
      index={props.index}
      hasBorderTopBottom={props.hasBorderTopBottom}
      isThumbed={props.isThumbed}
    />
  );
};

BackstagePodcastEpisodeListItem.propTypes = {
  pandoraId: PropTypes.string.isRequired,
  sectionLabel: PropTypes.string,
  index: PropTypes.number,
  isThumbed: PropTypes.bool,
  hasBorderTopBottom: PropTypes.bool,
};

export default BackstagePodcastEpisodeListItem;
